export const ROLE_OPTIONS = [
  ["admin", "Yönetici"], ["data_entry", "Veri Girişi / Proje"], ["proje_koordinatoru", "Proje Koordinatörü"], ["sube_yetkilisi", "Şube Yetkilisi"], ["gm_yetkili", "GM Yetkilisi"], ["taseron", "Taşeron"], ["taseron_kullanici", "Taşeron Kullanıcısı", "taseron"],
  ["muhasebe", "Muhasebe"], ["muhasebe_muduru", "Muhasebe Müdürü"], ["ik", "İK"], ["finans", "Finans"], ["satinalma", "Satınalma"], ["gmy", "GMY"], ["idari", "İdari İşler"],
  ["depo", "Depo"], ["kk_kullanici", "Kredi Kartı Kullanıcısı"], ["patron", "Patron"],
].map(([value, label, parent]) => ({ value, label, parent }));
export const TASERON_ROLES = ["taseron", "taseron_kullanici"];
export const isTaseronRole = (role) => TASERON_ROLES.includes(role);
// eski "proje" rolü "data_entry" (Veri Girişi / Proje) ile birleştirildi
export const normalizeRole = (role) => (role === "proje" ? "data_entry" : role);
export const ROLE_LABEL = Object.fromEntries(ROLE_OPTIONS.map((o) => [o.value, o.label]));
export const RESTRICTED_ROLES = ["sube_yetkilisi", "gm_yetkili"]; // taşeron ve taşeron fiyatları kapalı
export const PROJECT_SCOPED_ROLES = [...RESTRICTED_ROLES, "proje_koordinatoru"]; // yalnız yetkili olduğu proje/şubeleri görür (backend listeleri kısıtlar)
// SGK e-İşe Giriş / e-İşten Çıkış: yönetici her zaman; İK yalnız "can_sgk" yetkisi verilmişse
export const canSgk = (u) => u?.role === "admin" || (u?.role === "ik" && !!u?.can_sgk);

export const FIN_VIEW_ROLES = ["admin", "muhasebe", "muhasebe_muduru", "finans", "patron", "gmy"]; // Mali Veriler menüsü
export const FIN_EDIT_ROLES = ["admin", "muhasebe", "muhasebe_muduru", "finans"]; // banka kartı / mali veri düzenleme
export const canFinView = (u) => FIN_VIEW_ROLES.includes(u?.role);
export const canFinEdit = (u) => FIN_EDIT_ROLES.includes(u?.role);
export const LIMIT_RISK_ROLES = ["admin", "patron", "muhasebe", "muhasebe_muduru", "finans"]; // Veri Girişi → Limit Risk Bilgileri
export const canLimitRisk = (u) => LIMIT_RISK_ROLES.includes(u?.role);
export const LEDGER_ROLES = ["admin", "muhasebe", "muhasebe_muduru"]; // Muhasebe (genel muhasebe defterleri)
export const LEDGER_APPROVE_ROLES = ["admin", "muhasebe_muduru"]; // Muhasebe fişi onaylama / onay kaldırma (yalnız Muhasebe Müdürü)
export const canApproveEntry = (u) => LEDGER_APPROVE_ROLES.includes(u?.role);
export const PAYROLL_ROLES = ["admin", "muhasebe", "muhasebe_muduru", "ik"]; // Bordro
// Rol Yetki Matrisi hücre geçersiz kılmaları ("bölüm/satır/rol" → düzey) — /roles/sets ile gelir; yönetici her satırda tam yetkili
export const MATRIX_OVERRIDES = {};
export const matrixAllows = (u, section, row, levels = ["edit"]) => { if (u?.role === "admin") return true; const lv = MATRIX_OVERRIDES[`${section}/${row}/${u?.role}`]; return lv === undefined ? null : levels.includes(lv); };
export const canAdminDefs = (u) => matrixAllows(u, "admin", "defs") === true;
export const canDeleteEntries = (u) => matrixAllows(u, "entries", "delete") === true;
// Rol Yetki Matrisi'nden düzenlenen listeler: /roles/sets yanıtı bu dizileri yerinde günceller (menü ve sayfa yetkileri sunucuyla aynı kalır)
const ROLE_SETS = { FIN_VIEW_ROLES, FIN_EDIT_ROLES, LIMIT_RISK_VIEW_ROLES: LIMIT_RISK_ROLES, LEDGER_ROLES, LEDGER_APPROVE_ROLES, PAYROLL_ROLES };
export const applyRoleSets = (sets) => {
  Object.entries(ROLE_SETS).forEach(([k, arr]) => { if (Array.isArray(sets?.[k])) arr.splice(0, arr.length, ...sets[k]); });
  if (sets?.MATRIX_OVERRIDES && typeof sets.MATRIX_OVERRIDES === "object") { Object.keys(MATRIX_OVERRIDES).forEach((k) => delete MATRIX_OVERRIDES[k]); Object.assign(MATRIX_OVERRIDES, sets.MATRIX_OVERRIDES); }
};
// ATM Silim: silim girişi Veri Girişi › "ATM Silim Hizmeti Veri Girişi" içinde (taşeron dahil tüm roller); eski /atm-silim adresi oraya yönlenir

export const MENU_TREE = [
  { key: "/dashboard", label: "Dashboard & Özet" },
  { key: "/veri-girisi", label: "Veri Girişi", children: [["hizmet", "Hizmet Veri Girişi — tümü (sadece giriş)"], ["hizmet:personel", "Hizmet › Personel Hizmeti Veri Girişi"], ["hizmet:ekstra", "Hizmet › Ekstra Temizlik Hizmetleri Veri Girişi"], ["hizmet:atm", "Hizmet › ATM Silim Hizmeti Veri Girişi"], ["/onaylar", "Hizmet Onayı (sadece onay)"], ["personel", "Personel Girişi"], ["fatura", "Fiş/Fatura"], ["cek", "Çekler"], ["kredi", "Limit Risk / Banka Kredileri / Kredi Kartları"], ["maliyet", "Proje Maliyetleri"]] },
  { key: "/musteri-hakedis", label: "Müşteri Hakedişi" },
  { key: "/taseron-hakedis", label: "Taşeron Hakedişi" },
  { key: "/proje-maliyet", label: "Proje Maliyet Özeti" },
  { key: "/satis-pazarlama", label: "Satış Pazarlama" },
  { key: "/muhasebe", label: "Muhasebe" },
  { key: "/bordro", label: "Bordro" },
  { key: "/odeme-plani", label: "Ödeme Planı" },
  { key: "/butce", label: "Bütçe" },
  { key: "/kesilen-faturalar", label: "Kesilen Faturalar" },
  { key: "/demirbaslar", label: "Demirbaşlar" },
  { key: "/stoklar", label: "Stoklar" },
  { key: "/mali-veriler", label: "Mali Veriler" },
  { key: "/tanimlar", label: "Tanımlar", children: [["/tanimlar/projeler", "Projeler"], ["/tanimlar/hizmetler", "Hizmetler"], ["/tanimlar/butce-kalemleri", "Bütçe Kalemleri"], ["/tanimlar/sabit-tanimlar", "Sabit Tanımlar"], ["/tanimlar/kullanicilar", "Kullanıcılar"], ["/tanimlar/yetki-matrisi", "Rol Yetki Matrisi"], ["/tanimlar/yedek", "Yedek Al"]] },
  { key: "/cariler", label: "Cari Listesi" },
  { key: "/is-emirleri", label: "İş Emirleri" },
  { key: "/taseronlar", label: "Taşeronlar" },
];

// Hizmet Veri Girişi: Proje Yetkilisi, Proje Koordinatörü, GM Yetkilisi, İK ve Şube Yetkilisi için menü yetkisinden bağımsız açık (şube yetkilisi yalnız kendi şubesinin personelini görür)
export const HIZMET_DEFAULT_ROLES = ["data_entry", "proje_koordinatoru", "gm_yetkili", "ik", "sube_yetkilisi"];
const hizmetDefault = (user) => HIZMET_DEFAULT_ROLES.includes(normalizeRole(user?.role));

// menü görünür mü? admin: hepsi; permissions boşsa: eski davranış (hepsi); değilse yalnız izinliler
export const canSee = (user, path) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (isTaseronRole(user.role)) return path === "/is-emirleri" || path === "/sifre-degistir" || path === "/veri-girisi"; // taşeron: iş emirleri + Veri Girişi (yalnız ATM Silim)
  if (path === "/veri-girisi" && hizmetDefault(user)) return true;
  const p = user.permissions || {};
  if (!Object.keys(p).length) return user.role !== "sube_yetkilisi" && !isTaseronRole(user.role) ? true : path === "/onaylar" || path === "/dashboard" || path === "/is-emirleri";
  if (path === "/onaylar" && p["/onaylar"]) return true; // eski üst menü kaydı
  const top = MENU_TREE.find((m) => m.key === path || (m.children || []).some(([k]) => k === path));
  if (!top) return true;
  const perm = p[top.key];
  if (!perm) return false;
  if (top.key === path) return perm.includes("*") || perm.some((k) => k !== "/onaylar");
  return perm.includes("*") || perm.includes(path);
};

// alt menü (Veri Girişi › hizmet / personel / fatura …) görünür mü? "hizmet" için hizmet:personel / hizmet:ekstra / hizmet:atm alt yetkileri de yeterlidir
export const canSeeSub = (user, topKey, sub) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (isTaseronRole(user.role)) return topKey === "/veri-girisi" && sub === "hizmet"; // taşeron: yalnız Hizmet Veri Girişi (ATM Silim kutusu)
  if (topKey === "/veri-girisi" && sub === "hizmet" && hizmetDefault(user)) return true;
  const p = user.permissions || {};
  if (!Object.keys(p).length) return user.role !== "sube_yetkilisi";
  const perm = p[topKey];
  if (!perm) return false;
  return perm.includes("*") || perm.includes(sub) || (sub === "hizmet" && perm.some((k) => k.startsWith("hizmet:")));
};

// Hizmet Veri Girişi'nde görünen giriş türü kutuları: null = tümü (personel, ekstra, atm); taşeron → yalnız atm; yetkide yalnız hizmet:x varsa → o türler
export const allowedEntryGroups = (user) => {
  if (!user) return [];
  if (isTaseronRole(user.role)) return ["atm"];
  if (user.role === "admin") return null;
  const perm = (user.permissions || {})["/veri-girisi"] || [];
  if (perm.includes("*") || perm.includes("hizmet")) return null;
  const groups = perm.filter((k) => k.startsWith("hizmet:")).map((k) => k.slice(7));
  return groups.length ? groups : null; // açık hizmet:x kısıtı yoksa (varsayılan rol dahil) tümü
};
